<template>
  <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
    <div class="table__search-input-wrapper w-[350px] filter-search">
      <span class="pr-2 opacity-50"><search-icon /> </span>

      <input type="text" class="table__search-input" placeholder="Search..." />
    </div>

    <div v-if="transactions" class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipping ID(s)</span></label>
      <el-select filterable v-model="shippingID" placeholder="All"
       :disabled="isDisabled('shippingID')"
       @change="handleSelectChange('shippingID')">
        <el-option v-for="trans in transactions" :key="trans.id" :label="trans.shipping.shippingReference"
          :value="trans.shipping.shippingReference "
          >
        </el-option>
      </el-select>
    </div>

    <div v-if="bookings" class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipping ID(s)</span></label>
      <el-select filterable v-model="shippingID" placeholder="All"
       :disabled="isDisabled('shippingID')"
       @change="handleSelectChange('shippingID')">
        <el-option v-for="booking in bookings" :key="booking.id" :label="booking.shippingReference"
          :value="booking.shippingReference "
          >
        </el-option>
      </el-select>
    </div>

    <div class="actions flex items-center cursor-pointer mt-5">
      <div  @click="apply">
        <!-- <div  @click="applyCustomLogic"> -->
        <primary-button buttonText="Apply" :loading="loading" />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>

    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    bookings: {
      required: true,
    },
    transactions: {
      required: true,
    },
    
  },

  data() {
    return {
      selectedField: null,
      loading: false,
      // fleets: [],
      // routes: [],
      // filter: {
        shippingID: null,
        date: "",
        bookingChannel: "",
        origin: "",
        destination: "",
        sender: null,
        receiver: null,
        route: ""
      // },
    };
  },

  methods: {
    apply() {
      if (this.selectedField === 'sender') {
        const sender = this.sender
        this.$emit("appliedRef", sender)
      }else if(this.selectedField === 'receiver') {
        const receiver = this.receiver
        this.$emit("appliedRef", receiver)
      }else if(this.selectedField === 'shippingID'){
        const shippingID = this.shippingID
        this.$emit("appliedRef", shippingID)
      }
     
      this.closeModal()
      this.shippingID = null;
    },

    closeModal() {
      this.$emit("close-modal");
    }, 
    
    handleSelectChange(field) {
      // Set the selected field when an option is chosen
      if (this[field]) {
        this.selectedField = field;
      } else {
        this.selectedField = null;
      }
    },

    isDisabled(field) {
      // Disable all other select fields if one is selected
      return this.selectedField && this.selectedField !== field;
    },

  },
};
</script>

<style scoped lang="scss">
.label {
  @apply border-b-2 border-gray-400 w-full pb-1;
  font-size: 13px;
}

.individual-contaoner {
  @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
}

.filter-search {
  border-radius: 4px;
  @apply py-2
}
</style>
